export default {
    transform(valueKey, labelKey) {
        return (data) =>
            JSON.parse(data).map((option) => ({
                value: option[valueKey],
                label: option[labelKey],
                data: option,
            }))
    },
}
